var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87495 11.5C5.87495 11.8452 6.15477 12.125 6.49995 12.125C6.84513 12.125 7.12495 11.8452 7.12495 11.5L7.12495 7.125L11.5 7.125C11.8452 7.125 12.125 6.84518 12.125 6.5C12.125 6.15482 11.8452 5.875 11.5 5.875L7.12495 5.875V1.5C7.12495 1.15482 6.84513 0.875 6.49995 0.875C6.15477 0.875 5.87495 1.15482 5.87495 1.5V5.875H1.5C1.15482 5.875 0.875 6.15482 0.875 6.5C0.875 6.84518 1.15482 7.125 1.5 7.125H5.87495L5.87495 11.5Z",
    fill: "#01021D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlack);
export default __webpack_public_path__ + "static/media/add-black.5be0441551c58963093a182d201d0ed2.svg";
export { ForwardRef as ReactComponent };